import { render } from "./PageNumber12.vue?vue&type=template&id=2221a6bf&scoped=true"
import script from "./PageNumber12.vue?vue&type=script&lang=js"
export * from "./PageNumber12.vue?vue&type=script&lang=js"

import "./PageNumber12.vue?vue&type=style&index=0&id=2221a6bf&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2221a6bf"]])

export default __exports__